import { apiRequest, withToken } from './http-client';

export const getMenu = async ( token ) => {
    return apiRequest({
        method: 'get',
        url: '/front/menu/',
        headers: withToken(token)
    }, 'No se pudo obtener el menú');
}

export const getRecords = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/front/records/',
        headers: withToken(token),
        params,
    }, 'No se pudieron obtener los records');
}

export const getDashboard = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/front/dashboard/',
        headers: withToken(token),
        params,
    }, 'No se pudo obtener el dashboard');
}

export const getDashboardTickets = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/front/dashboard/tickets/',
        headers: withToken(token),
        params,
    }, 'No se pudo obtener el dashboard de tickets');
}